// Help to sort an array by comparing two arguments

export default {
    computed: {
        sortUsers() {
            return this.filterUsers.sort(this.compare)
        },
        sortChannels() {
            return this.channelsFilter.sort(this.compare)
        }
    },
    methods: {
        compare(a, b) {
            if(a[this.sort.type] == null) a[this.sort.type]=""
            if(b[this.sort.type] == null) b[this.sort.type]=""
            if(!isNaN(a[this.sort.type])){
                return a[this.sort.type] <  b[this.sort.type] ?  this.sort.order : - this.sort.order
            }
            return a[this.sort.type].toUpperCase() <  b[this.sort.type].toUpperCase() ?  this.sort.order : - this.sort.order
        },
    }
}